import Paper from './Paper';
export default Paper;
//# sourceMappingURL=index.js.map